<template>
    <div>
        <b-form-group>
            <div v-for="(field, index) in form" :key="index">
                <b-input-group class="mb-2">
                    <b-form-input
                        class="mb-0 tb-form-field tb-form-field--with-side-by-side"
                        type="text"
                        v-model="field.label"
                        disabled
                        placeholder="Field name"
                    >
                    </b-form-input>

                    <b-input-group-append>
                        <b-button
                            class="tb-form-field__side-by-side tb-form-field__side-by-side--danger"
                            @click.prevent="removeField(index)">
                            Remove
                        </b-button>
<!--
                            variant="danger"-->
                    </b-input-group-append>
                </b-input-group>
            </div>

            <b-input-group>
                <b-form-input
                    class="mb-0 tb-form-field tb-form-field--with-side-by-side"
                    type="text"
                    v-model="new_field.label"
                    placeholder="type custom field">
                </b-form-input>

                <b-input-group-append>
                    <b-button
                        class="tb-form-field__side-by-side"
                        @click.prevent="addField" :disabled="new_field.label.length == 0">
                        Add
                    </b-button>
                    <!--
                                                variant="danger"-->
                </b-input-group-append>
            </b-input-group>

<!--            <b-input-group class="mt-3">-->
<!--                <b-input-group-append>-->
<!--                    <b-button class="tb-form-button" @click.prevent="addField" :disabled="new_field.label.length == 0">-->
<!--                        type custom field-->
<!--                    </b-button>-->
<!--                </b-input-group-append>-->
<!--            </b-input-group>-->
        </b-form-group>
    </div>
</template>

<script>
    import slugify from 'slugify';

    export default {
        props: {
            fields: {
                default: () => []
            }
        },

        data() {
            return {
                form: [],
                new_field: {
                    label: "",
                    name: ""
                }
            }
        },

        mounted() {
            this.form = [ ...this.fields ];
        },

        watch: {
            form: {
                handler(new_form) {
                    this.$emit('changed', new_form);
                },
                
                deep: true
            }
        },

        methods: {
            addField() {
                this.form.push({
                    label: this.new_field.label,
                    name: this.toSlug(this.new_field.label)
                });

                this.new_field = {
                    label: "",
                    name: ""
                }
            },
            
            removeField(idx) {
                this.$delete(this.form, idx);
            },

            toSlug(label) {
                return slugify(label, {
                    replacement: '_',    // replace spaces with replacement
                    remove: null,        // regex to remove characters
                    lower: true          // result in lower case
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>